import { ZomentumEntity, TableQueryFilter } from "../../common";
import { EmailThreadRecipients } from "../../Others/EmailThread";
import { MergeTagVariable } from "../../Documents";
import { VendorUserData } from "../User";
import { UserData } from "../../Users";

export interface VendorEmailTemplateFileDetails {
	file_id: string;
	file_name: string;
	file_size?: number;
}
export interface VendorSystemEmailTemplateContent {
	readonly heading?: string;
	readonly button_text?: string;
	readonly end_salutation?: string;
}

export class VendorEmailTemplateRequest {
	name = "";
	subject = "";
	body = "";
	file_details = new Array<VendorEmailTemplateFileDetails>();
	custom_template_type: VendorCustomTemplateType | null = null;
	system_template_info?: VendorSystemEmailTemplateContent | null = null;
}

export class VendorEmailTemplate extends ZomentumEntity {
	id = "";
	name = "";
	subject = "";
	body = "";
	file_details?: VendorEmailTemplateFileDetails[] =
		new Array<VendorEmailTemplateFileDetails>();
	merge_tags_system_variables: MergeTagVariable[] =
		new Array<MergeTagVariable>();
	user: UserData = new UserData();
	created: Date = new Date();
	updated: Date = new Date();
	custom_template_type: VendorCustomTemplateType | null = null;
	deleted = false;
	defaultTemplate?: boolean = false;
	system_template_info?: VendorSystemEmailTemplateContent | null = null;
	vendor: VendorUserData = new VendorUserData();
	template_visible = true;
}

export class VendorEmailTemplatesDrawerFormValues {
	title = "";
	subject = "";
	body = "";
}

export enum VendorCustomTemplateType {
	PublishTemplate = "publish_template",
	UnpublishTemplate = "unpublish_template",
	OpportunityShared = "opportunity_shared",
	OpportunityReceived = "opportunity_received",
	AcceptInviteFlow = "accept_invite_flow",
	JoinVendorProgram = "join_vendor_program",
	InviteNewPartner = "invite_new_partner",
	InviteExistingPartner = "invite_existing_partner",
	AssignPartnerTier = "partner_tier_assigned",
	ChangePartnerTier = "partner_tier_changed"
}

export class VendorEmailTemplatesResponse {
	filtered_count_map = null;
	data: VendorEmailTemplate[] = new Array<VendorEmailTemplate>();
}

export interface VendorEntitySelectionFormProps {
	client: string;
	opportunity: string;
	documents: string;
	recipients: string[];
}

export class VendorEntitySelectionFormValues {
	client = "";
	opportunity: string | null = null;
	documents: string | null = null;
	recipients: string[] = new Array<string>();
	partner: string | null = null;
}

export class VendorSelectedEntityValues {
	client = "";
	opportunity: string | null = null;
	documents: string | null = null;
	recipients: EmailThreadRecipients[] = new Array<EmailThreadRecipients>();
	partner: string | null = null;
}

export class VendorUseTemplateValues {
	subject = "";
	body = "";
	attachments = new Array<VendorEmailTemplateFileDetails>();
	entity_details: VendorSelectedEntityValues =
		new VendorSelectedEntityValues();
}

export class VendorEmailTemplateGetRequest {
	filters: TableQueryFilter[];
	keywords: string | null;
	constructor(filters: TableQueryFilter[], keywords: string | null) {
		this.filters = filters;
		this.keywords = keywords;
	}
}

export class VendorPreviewEmailTemplateRequest {
	from: EmailThreadRecipients | null = null;
	subject = "";
	body = "";
	should_replace_with_empty_string = true;
	document_id = "";
	template_type: VendorCustomTemplateType =
		VendorCustomTemplateType.PublishTemplate;
}

export interface VendorPreviewSystemEmailTemplate {
	from: {
		email: string;
		name: string;
	};
	subject: string;
	body: string;
	to: [];
}

export enum VendorEmailTemplateAddOrEditMode {
	ADD = "add",
	EDIT = "edit"
}
